import { Component, OnInit, Inject, Output, EventEmitter, Input } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import swal from 'sweetalert2';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';
import { OtherClinicModel } from 'src/app/models/OtherClinicModel';
import { OtherClinicService } from 'src/app/services/OtherClinicService';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
@Component({
  selector: 'app-otherclinicentry',
  templateUrl: './otherclinicentry.component.html',
  styleUrls: ['./otherclinicentry.component.css']
})
export class OtherclinicentryComponent implements OnInit {

  patientcode = '';
  clinicdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  cliniclocation = '';
  clinicnotes = '';
  docdepartment = '';
  userid = '';
  username = '';
  clinictime = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  Patientname = '';


  clinicnotestext= '';


  // Doctors Data
  docCode = this.storage.retrieve('stgConsultant');
  docName = '';
  docDepartment = '';


  //  company data
  compCode ='' ;
  compName ='' ;

  // Tool Bar
  editorConfigNoToolbar = {
    editable: true,
    spellcheck: true,
    showToolbar: true,  // 🚫 This hides the toolbar
    height: '150px',
    frameElement:true,
    minHeight: '0',
    placeholder: '',
    translate: 'yes',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    toolbarHiddenButtons: []
  };
  @Output() submitClicked = new EventEmitter<any>();



   companyList : CompanyModel[]=[];
   DoctorList : DoctorsModel []=[];
     otherClinicList : OtherClinicModel []=[];
  constructor(
    public dialogRef: MatDialogRef<OtherclinicentryComponent>,
    public storage: LocalStorageService,
    public otherclinic : OtherClinicModel,
    public otherclinicService : OtherClinicService,
    public CompanyService : CompanyService,
    public DoctorsService: DoctorsService,
    public Doctor : DoctorsModel,
          @Inject(MAT_DIALOG_DATA) public data :any,) {
        this.patientcode = data.patientcode;
        this.Patientname = data.Patientname;
        this.clinicnotes = data.clinicnotes;
        this.docdepartment = data.docdepartment;
        this.clinicdate =   formatDate(data.progdate, 'yyyy-MM-dd', 'en');
        this.username= data.username;


      }

  ngOnInit(): void {
        this.retriveCompanyLookupTop();
        this.cliniclocation = this.storage.retrieve('stgLocation');
        this.retriveDoctor ();
  }
    updatePlainText() {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = this.clinicnotes || '';
    this.clinicnotestext = tempElement.textContent || '';
  }

    mesgSave() {
          swal({
          title: 'Your work has been saved',

          type: 'success',
          showConfirmButton: false,

          timer: 1500
          });
    }

      Exit_Data(){
      this.dialogRef.close();
    }
      retriveCompanyLookupTop() {
    this.CompanyService.getLocationLookupTop('1').subscribe((data: CompanyModel[]) => {

        for (let i = 0; i < data.length; i++) {
          this.companyList[i] = data[i];
        }

      });
  }

  retriveDoctor() {
    this.DoctorsService.getdoctors(this.storage.retrieve('stgEmpId'),this.storage.retrieve('stgCompCode')).subscribe((data: DoctorsModel) => {
        this.docdepartment = data.docDepartment

    })

  }


   SubmitClinic(){
        this.clinictime  =formatDate(new Date(), 'HH:mm', 'en');
        const str1 = formatDate(this.clinicdate, 'yyyy-MM-dd', 'en');
        this.otherclinic.patientcode= this.patientcode;
        this.otherclinic.clinicdate= this.clinicdate;
        this.otherclinic.cliniclocation= this.cliniclocation;
        this.otherclinic.clinicnotes= this.clinicnotes;
        this.otherclinic.docdepartment = this.docdepartment;
        this.otherclinic.userid = this.storage.retrieve('stgUserId');
        this.otherclinic.username= this.storage.retrieve('stgusername');
        this.otherclinic.clinictime= str1;
        this.otherclinicService.AddOtherClinic(this.otherclinic).subscribe(data => {
        this.mesgSave();
        this.dialogRef.close();
          },
            error => { alert(error); }
          );
      }


      retriveOtherClinicLine (){
      this.otherclinicService.getotherclinicline(this.patientcode,this.docdepartment,this.clinicdate).subscribe((data : OtherClinicModel)=>{
          this.patientcode = data.patientcode;
          this.clinicdate = data.clinicdate;
          this.cliniclocation=data.cliniclocation;
          this.clinicnotes = data.clinicnotes;
          this.docdepartment = data.docdepartment;
          this.username = data.username;
          this.clinicdate = data.clinicdate;

      });
    }


}
